import React from "react";

interface EmptyProps {}

export const Empty: React.FC<EmptyProps> = () => {
  return null;
};
